module.exports = __webpack_public_path__ + "img/16.9f79ef45.jpg";